<template>
  <div
    class="container"
    style="min-height: 100vh; max-height: 100vh; overflow-y: auto"
  >
    <div class="row recommendation-title">
      <div class="col-md-8 my-4">
        <h5 class="mb-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 172 172"
            style="fill: #000000"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g id="original-icon" fill="#f1c40f">
                <path
                  d="M78.83333,0v21.5h14.33333v-21.5zM30.26237,20.12826l-10.13411,10.13411l15.20117,15.20117l10.13411,-10.13411zM141.73763,20.12826l-15.20117,15.20117l10.13411,10.13411l15.20117,-15.20117zM86,35.83333c-27.66333,0 -50.16667,22.50333 -50.16667,50.16667c0,19.95917 11.74617,37.18391 28.66667,45.25358v19.24642c0,7.90483 6.4285,14.33333 14.33333,14.33333h14.33333c7.90483,0 14.33333,-6.4285 14.33333,-14.33333v-19.24642c16.9205,-8.06967 28.66667,-25.29441 28.66667,-45.25358c0,-27.66333 -22.50333,-50.16667 -50.16667,-50.16667zM0,78.83333v14.33333h21.5v-14.33333zM150.5,78.83333v14.33333h21.5v-14.33333zM35.32943,126.53646l-15.20117,15.20117l10.13411,10.13411l15.20117,-15.20117zM136.67057,126.53646l-10.13411,10.13411l15.20117,15.20117l10.13411,-10.13411z"
                ></path>
              </g>
            </g>
          </svg>
          Smart recommendations
        </h5>
      </div>
    </div>

    <div class="recommendation-category">Active recommendations</div>
    <div class="line">
      <div class="row w-100">
        <div
          class="col-md-12 recommendation"
          v-for="(item, i) in recommendation"
          v-bind:key="i"
        >
          <div class="header2 font-weight-bold">
            <vue-markdown>{{ item.title }}</vue-markdown>
          </div>
          <div class="detail">
            <vue-markdown>{{ item.body }}</vue-markdown>
          </div>
          <div class="badge badge-success">{{ item.feature }}</div>
          <div class="footer">
            <div class="float-left mt-2">
              <i class="text-muted">{{ timeSince(item.created_at) }}</i>
            </div>
            <div class="float-right" v-if="item.link">
              <a :href="item.link" target="_blank">
                <button class="btn btn-cta">
                  {{ item.link_text || 'View' }}
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row w-100">
        <div class="col-md-12 recommendation">
          <div class="header2">Create <b>Survey</b> automation</div>
          <div class="detail">
            On average, A/B testing is going to see an improvement of 20% after
            x days
          </div>
          <div class="footer">
            <div class="float-left">
              <i class="text-muted">15 minutes ago</i>
            </div>
            <div class="float-right">
              <button class="btn btn-first">Apply</button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
const VueMarkdown = () => import('vue-markdown')

export default {
  components: {
    VueMarkdown,
  },
  data: function () {
    return {
      recommendation: null,
    }
  },
  mounted() {
    this.$http
      .get(process.env.API_ENDPOINT + '/recommendation/list')
      .then((response) => {
        this.recommendation = response.data
      })
      .catch((err) => {
        alert(err)
      })
  },
  methods: {
    timeSince(x) {
      return moment(x).fromNow()
    },
  },
}
</script>

<style scoped>
.recommendation-category {
  font-weight: bold;
  margin: 20px 0px 10px 0px;
}
.line {
  border-left: 2px #cfcfcf dashed;
  padding-left: 10px;
}
.recommendation-title {
  background-color: #f7f7f7;
}
.recommendation {
  border-radius: 4px;
  /* border: 1px solid #d7d7d7; */
  background-color: #f7f7f7;
  padding: 20px 20px;
  margin: 5px 20px 10px 20px !important;
}

.recommendation .detail {
  background: white;
  /* border: 1px solid #cfcfcf; */
  margin: 12px 4px;
  padding: 14px 10px;
  border-radius: 8px;
}

#profile-picture {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-image: url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfwXmi4mI9pCF-hNdTgNLSCBOihecmhgfVPA&usqp=CAU');
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  border: 1px solid #cfcfcf;
  box-shadow: 0px 0.5px 1px #cfcfcf;
  cursor: pointer;
}

.speech {
  background-color: white;
  border-radius: 8px;
  width: 100%;
  padding: 20px;
  border: 1px solid #cfcfcf;
  box-shadow: 0px 0.5px 1px #cfcfcf;
  z-index: 9999999 !important;
}

.speech:not(:nth-child(1)) {
  margin-top: 20px;
}

.speech-container {
  margin-bottom: 80px;
  vertical-align: bottom;
  max-height: 500px;
  overflow-y: auto;
}

.btn-close {
  background: #0000005c;
  color: white;
  width: 70px;
  border-radius: 50px;
  text-align: center;
  margin-bottom: 10px;
  margin-left: auto;
  cursor: pointer;
  padding: 2px 0px;
  opacity: 0;
}

#bot-container:hover .btn-close {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/SmartRecommendation.vue